import { appConfig } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const badmadRobotsQuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-wishlist-added",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Gameplay trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/badmad-robots/BadmadRobotsTrailer.mp4`,
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-trailer-watched",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-discord-followed",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-discord",
    linkUrl: "https://discord.com/invite/badmadrobots",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow BADMAD ROBOTS on X",
    caption: "Don't miss a tweet",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-twitter-followed",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-twitter",
    linkUrl: "https://x.com/badmadrobots",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Wishlist BADMAD ROBOTS on Steam",
    caption: "Get early game play access",
    linkUrl: "https://store.steampowered.com/app/2841160/BADMAD_ROBOTS/",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-website-visited",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-website",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "550e8400-e29b-41d4-a716-446655440000-onboarding-completed",
    ruleId: "550e8400-e29b-41d4-a716-446655440000-onboarding",
  },
];

export const badmadRobotQuests: QuestGroup[] = [
  {
    key: "level-0",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 50,
    quests: badmadRobotsQuestsList,
  },
];
